import React from "react";
import BackgroundDiv from "../misc/elements/BackgroundDiv";
import { getTimeString } from "../misc/helperfuncs";

const TimePassed = ({ timePassed, totalPassed, width = "25%" }) => {
  return (
    <div
      className="divColumn"
      style={{
        zIndex: 1,
        marginLeft: "5px",
        width,
        height: "100%",
        marginTop: "15px",
      }}
    >
      <div
        className="divRow"
        style={{
          position: "relative",
          padding: "3px",
          justifyContent: "center",
          width: "80%",
        }}
      >
        <BackgroundDiv
          backgroundColor={"#2f2f2f"}
          opacity={0.8}
          borderBottom={true}
        />
        <div className="textBold" style={{ zIndex: 1, color: "white" }}>
          In Active
        </div>
      </div>
      <TimeHolder timePassed={timePassed} type="This Time" />
      <TimeHolder timePassed={totalPassed} type="Total" />
    </div>
  );
};

const TimeHolder = ({ timePassed, type }) => {
  return (
    <div
      className="divRow"
      style={{
        width: "80.5%",
        justifyContent: "space-between",
        position: "relative",
        borderBottom: type == "This Time" ? "1px solid white" : null,
        padding: "3px",
        marginRight: "7px",
      }}
    >
      <BackgroundDiv
        backgroundColor={"#8f8f8f"}
        noBorder={type == "This Time"}
        borderTop={type == "Total"}
      />
      <div
        className="textWhite"
        style={{ zIndex: 1, marginLeft: "2px", fontStyle: "italic" }}
      >
        {type}
      </div>
      <div className="divRow" style={{ zIndex: 1 }}>
        <div
          className="textBold"
          style={{ fontSize: "15px", marginLeft: "3px", textAlign: "center" }}
        >
          {timePassed.seconds > 120
            ? timePassed.minutes >= 120
              ? getTimeString(timePassed.minutes).text
              : `${timePassed.minutes} mins`
            : `${timePassed.seconds} seconds`}
        </div>
        <img
          src={"/icons/icon_time.png"}
          style={{ objectFit: "contain", height: "30px" }}
        />
      </div>
    </div>
  );
};

export default TimePassed;
